import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import logo from './centrosura.png';
import './ComingSoon.css';

// Mensaje de la pantalla "Muy pronto" (módulo visible en el sidebar pero tapado).
//
// --- Mensaje original (respaldo). Para revertir, reemplaza MESSAGE por esto: ---
// const MESSAGE = {
//   title: 'Muy pronto',
//   main: 'Estamos preparando algo para ti.',
//   light: 'Esta experiencia estará disponible próximamente.',
// };
const MESSAGE = {
  title: 'Más pronto de lo que crees',
  main: 'Estamos afinando los últimos detalles para reabrir este módulo.',
  light: 'Gracias por tu participación en las inducciones y por cada sugerencia que nos diste.',
};

const ComingSoon = ({ moduleName }) => {
  const msg = MESSAGE;
  const navigate = useNavigate();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="coming-soon-container">
      {/* Subtle grid pattern */}
      <div className="coming-soon-grid" />

      {/* Floating orbs - very subtle */}
      <div className="coming-soon-orb coming-soon-orb-1" />
      <div className="coming-soon-orb coming-soon-orb-2" />

      <div className="coming-soon-content">
        {/* Logo */}
        <motion.div
          className="coming-soon-logo-wrapper"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <img
            src={logo}
            alt="Centro SURA"
            className="coming-soon-logo"
          />
        </motion.div>

        {/* Divider line */}
        <motion.div
          className="coming-soon-divider"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.6, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
        />

        {/* Module name pill */}
        {moduleName && (
          <motion.div
            className="coming-soon-pill"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            {moduleName}
          </motion.div>
        )}

        {/* Main message */}
        <motion.h1
          className="coming-soon-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          {msg.title}
        </motion.h1>

        <motion.p
          className="coming-soon-subtitle"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.75, ease: [0.16, 1, 0.3, 1] }}
        >
          {msg.main}
          <br />
          <span className="coming-soon-subtitle-light">
            {msg.light}
          </span>
        </motion.p>

        {/* Animated dots */}
        <motion.div
          className="coming-soon-dots"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 1 }}
        >
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="coming-soon-dot"
              style={{ animationDelay: `${i * 0.3}s` }}
            />
          ))}
        </motion.div>

        {/* Back button */}
        <motion.button
          className="coming-soon-back"
          onClick={() => navigate('/inicio')}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 1.1 }}
          whileHover={{ x: -3 }}
        >
          <ArrowLeft size={16} />
          Volver al inicio
        </motion.button>
      </div>
    </div>
  );
};

export default ComingSoon;
